// extracted by mini-css-extract-plugin
export var inline = "_vx-0";